/** @format */

const template = `
<div class="title-container">
  <h3 ng-if="!ctrl.required" translate>SIS_COMPONENTS.PERSON.RESPONSIBLE_ASSESSOR.TITLE</h3>
  <label ng-if="ctrl.required" class="required" translate>SIS_COMPONENTS.PERSON.RESPONSIBLE_ASSESSOR.TITLE</label>
  <div class="check-custom-assessors" ng-if="!ctrl.editDisabled">
    <button type="button" class="btn btn-primary btn-naked btn-sm" ng-if="!ctrl.editMode" ng-click="ctrl.toggleEditMode()">
      <sis-icon icon="edit"></sis-icon><span translate>SIS_COMPONENTS.PERSON.RESPONSIBLE_ASSESSOR.EDIT_LINK</span>
    </button>
    <button type="button" class="btn btn-primary btn-naked btn-sm" ng-if="ctrl.editMode" ng-click="ctrl.toggleEditMode()">
      <sis-icon icon="back"></sis-icon><span translate>SIS_COMPONENTS.PERSON.RESPONSIBLE_ASSESSOR.RESET_LINK</span>
    </button>
  </div>
  <div class="guidance-text" ng-if="ctrl.required">
    <p class="guidance" translate>STUDIES.COURSE_UNIT_EVALUATION.GUIDANCE_RESPONSIBLE_ASSESSOR</p>
  </div>
</div>

<ul ng-if="!ctrl.editMode">
  <li class="empty-selection" ng-if="ctrl.responsibleTeachers.length==0" translate> SIS_COMPONENTS.PERSON.RESPONSIBLE_ASSESSOR.NONE </li>
  <li ng-repeat="fullName in ctrl.responsibleTeachersNames track by $index"> {{fullName}} </li>
</ul>
<choose-employees
  ng-if="ctrl.editMode"
  selected-employees="finalEvaluations[0].responsibleAssessorPersons"
  on-select="ctrl.saveResponsibleAssessors">
</choose-employees>
`;
export default template;
